import { get } from 'svelte/store';
import { storeBackendUrl, storeAccessToken, storeError } from '../store';
import { authentication } from './api';
import { addNotificationInfo, addNotificationError } from '../toaster';
/**
 * Creation d'un contact Sendinblue
 */
export async function createContact(lastName, firstName, ptce_o_n, ptce_name, email) {
    if (email == undefined || email == "" ||
        firstName == undefined || firstName == "" ||
        lastName == undefined || lastName == "" ||
        ptce_o_n == undefined || ptce_o_n == "") {
        storeError.set("Veuillez renseigner tous les champs");
        return false;
    }
    const apiUrl = get(storeBackendUrl) + "v1/newsletters/";
    await authentication();
    const data = {
        last_name: lastName,
        first_name: firstName,
        ptce_o_n: ptce_o_n,
        ptce_name: ptce_name,
        email: email,
    };
    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + get(storeAccessToken));
    var myInit = {
        method: 'POST',
        headers: myHeaders,
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(data),
    };
    return await fetch(apiUrl, myInit)
        .then(function (response) {
        if (!response.ok) {
            throw new Error(response.status.toString());
        }
        else {
            return response.json();
        }
    })
        .then((data) => {
        addNotificationInfo("Demande envoyée");
        return true;
    })
        .catch((error) => {
        addNotificationError("Problème lors de la demande d'inscription");
        return false;
    });
}
